import useDashboardAccess from "@/hooks/useDashboardAccess";
import { useAuth } from "@/context/auth";
import SmsBalanceLink from "@/modules/smsCredit/BalanceLink";
import { SubscriptionChip } from "@/modules/subscription/SubscriptionNotices";
import { ActionIcon, Group } from "@mantine/core";
import { IconLogout, IconUserCircle } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

function Header() {
  const navigate = useNavigate();
  const { isManager } = useDashboardAccess();
  const { logout } = useAuth();
  return (
    <Group justify="space-between" align="center" px="xs" h={60}>
      <Group gap="xs">
        <SmsBalanceLink />
        <SubscriptionChip />
      </Group>
      {/* <Menu shadow="md" withinPortal>
        <Menu.Target> */}
      <ActionIcon
        aria-label={isManager ? "پروفایل" : "خروج"}
        onClick={isManager ? () => navigate("/dashboard/profile") : logout}
        radius="xl"
        variant="light"
        size="lg"
      >
        {isManager ? <IconUserCircle stroke={1.5} size={30} /> : <IconLogout stroke={1.5} size={24} />}
      </ActionIcon>
      {/* </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item leftSection={<IconInfoCircle size={14} />}>
            ویرایش اطلاعات
          </Menu.Item>
        </Menu.Dropdown>
      </Menu> */}
    </Group>
  );
}

export default Header;
